export default "__VITE_ASSET__BfGZs3im__"